import { Component, Input, ViewContainerRef } from '@angular/core';
import { ExaView } from './exa-view';

@Component({
    selector: 'exa-insert-view',
    templateUrl: 'exa-insert-view.component.html',
    styleUrls: ['exa-insert-view.component.css']
})

export class ExaInsertViewComponent {
    @Input() view: ExaView;

    constructor(
        private vcr: ViewContainerRef) { }

    ngOnInit() {
        if (this.view != null) {
            this.vcr.createEmbeddedView(this.view.template, this.view.context);
        }
    };

}


// WEBPACK FOOTER //
// ./src/app/exa/exa-insert-view/exa-insert-view.component.ts